export default __webpack_public_path__ + "static/media/image.e3938836.svg";